import {  Route, Switch, useHistory} from 'react-router-dom'
import React, {useState, createContext} from 'react'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const ResetPassword = React.lazy(() => import('./views/security/ResetPassword'));
const TheLayout = React.lazy(() => import('./views/containers/TheLayout'));
const Login = React.lazy(() => import('./views/security/Login'));

const ReceiptCompositePayment = React.lazy(() => import('./views/compositereceipting/ReceiptCompositePayment'));
const MoMoPayment = React.lazy(() => import('./views/web_payments/MoMoPayment'));
const CardPayment = React.lazy(() => import('./views/web_payments/CardPayment'));
const WebPayment = React.lazy(() => import('./views/web_payments/WebPayment'));

export const AppStateHandlersContext = createContext();
export const AppStateContext = createContext();

function App() {

  let appHistory = useHistory();

  const [appState, setAppState] = useState(
      {
        loggedIn:false,
        auth:{},
        sidebarShow:'responsive',
        itemToEdit:{}
      }
    )

  const handleAppHistory = (path,data=null) =>{
      if(data){
        appHistory.push(path,data);
      }else{      
        appHistory.push(path);
      }
    }

  const handleToggleSidebar = (val)=>{
      setAppState({
          ...appState,
          sidebarShow:val
        })
    }

  const handleItemToEdit = (item)=>{
    setAppState({
        ...appState,
        itemToEdit:item
      }) 
    }
    
  const RequireAuth = ({ children }) => {
      if (!appState.loggedIn) {
        return <Route  name="Login Page"  render={(props) => <Login {...props}/>} />
      }
      return children;
    };

  const handleAuth = (isLogin, credentials) =>{
      if(isLogin){
        appHistory.push("/");
        setAppState({
            ...appState,
            auth:credentials,
            loggedIn:true
          })      
      }else{
        setAppState({
            ...appState,
            auth:{},
            loggedIn:false
          }) 
      }
    }

  const stateHandlers={
      handleAppHistory,
      handleAuth,
      handleToggleSidebar,
      handleItemToEdit
    }

  return (
    <AppStateContext.Provider value = {appState}>
      <AppStateHandlersContext.Provider value ={stateHandlers}>
          <React.Suspense fallback={loading}>
            <Switch>

              <Route  exact path="/billpaymis/resetpassword" name="Reset Password"  render={(props) => <ResetPassword {...props}/>} />

              <Route  exact path="/billpaymis/chambeshi" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/chambeshi/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/chambeshi/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/chambeshi" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/chambeshi" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/mazabuka" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/mazabuka/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/mazabuka/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/mazabuka" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/mazabuka" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/lukanga" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />              
              <Route  exact path="/billpaymis/lukanga/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/lukanga/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/lukanga" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/lukanga" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/kafubu" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/kafubu/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/kafubu/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/kafubu" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/kafubu" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/swasco" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/swasco/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/swasco/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/swasco" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/swasco" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/nkana" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/nkana/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/nkana/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/nkana" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/nkana" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/luapula" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/luapula/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/luapula/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/luapula" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/luapula" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />

              <Route  exact path="/billpaymis/mulonga" name="Web Payment"  render={(props) => <WebPayment {...props}/>} />
              <Route  exact path="/billpaymis/mulonga/momopayment" name="MoMo Payment"  render={(props) => <MoMoPayment {...props}/>} />
              <Route  exact path="/billpaymis/mulonga/cardpayment" name="Card Payment"  render={(props) => <CardPayment {...props}/>} />
              <Route  exact path="/billpaymis/cardpaymentstatus/mulonga" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <Route  exact path="/billpaymis/compositepayment/mulonga" name="Card Payment Status"  render={(props) => <ReceiptCompositePayment {...props}/>} />
              <RequireAuth>
                  <Route  path="/" name="Home" render={(props) => <TheLayout {...props} />} />
              </RequireAuth>

            </Switch>
          </React.Suspense>
      </AppStateHandlersContext.Provider>
    </AppStateContext.Provider>
  );

}
export default App;